/* eslint-disable */
import $router from '@/router.js';
import $api from '@/services/api.js';
import * as Sentry from '@sentry/browser';

const $auth = {};

$auth.authenticate = async () => {
  if ($auth.user) {
    return Promise.resolve();
  }
  if (!localStorage.id_token) {
    const scope = 'openid email profile';
    const clientId = '1185758f-549b-4421-9acf-29f0b8a92719';
    const auth_redirect_uri = `${window.location.origin}/auth/index.html`;
    const response_type = 'id_token';
    const nonce = `now.${Date.now()}`;
    // gokaizen.com
    const login_uri = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&scope=${encodeURIComponent(scope)}&response_type=${response_type}&redirect_uri=${encodeURIComponent(auth_redirect_uri)}&nonce=${encodeURIComponent(nonce)}`;
    window.location.href = login_uri;
  } else {
    const user = await $api.get('/v1/internal/me');
    $auth.user = user;
    $auth.services = $router.options.routes.filter((route) => route.meta && route.meta.displayName && user.permissions.includes(route.meta.accessControl));
    Sentry.setUser({ email: user.email });
    return user;
  }
};

export default $auth;
